/**
 * 「全部保存」存完之后该怎么说。
 *
 * ## 为什么单独一个文件
 *
 * 这个逻辑原来写在内容页组件里，而那个组件挂载一次要 mock 十几个接口；
 * 最值得盯住的恰恰是**文案**，不是流程：
 *
 *   · 本页内容存了，但页面还是**草稿** —— 访客仍然看不到，必须补一句；
 *   · 页头页脚没有草稿态，存完立刻**全站生效**，也必须说清楚；
 *   · 两边只有一边失败时不能笼统说"保存失败"，否则客户会把两边都重做一遍。
 *
 * 说错一句，客户就以为已经上线了。所以抽出来单测。
 */
export interface SaveOutcomeInput {
  /** 这次真的提交了本页内容吗 —— 没改过就别在结果里提它 */
  needPage: boolean;
  needShell: boolean;
  pageOk: boolean;
  shellOk: boolean;
  /** 页面当前的发布态。决定"保存成功"要不要补一句"还是草稿" */
  pagePublished: boolean;
}

export function describeSaveOutcome(input: SaveOutcomeInput): string {
  const lines: string[] = [];
  if (input.needPage) {
    if (!input.pageOk) lines.push('本页内容没保存成功');
    else if (input.pagePublished) lines.push('本页内容已保存，访客马上能看到');
    else lines.push('本页内容已保存，但这一页还是草稿 —— 点「发布」后访客才能看到');
  }
  if (input.needShell) {
    lines.push(input.shellOk ? '页头页脚已保存，全站生效' : '页头页脚没保存成功');
  }
  const allOk = input.pageOk && input.shellOk;
  return `${lines.join('；')}。${allOk ? '' : '具体原因见上方报错。'}`;
}
